
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyPolartwilightColour as ObiSlightlycloudyPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-polartwilight-colour.js';
 
 
 

 
 export const ObiSlightlycloudyPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-polartwilight-colour',
   elementClass: ObiSlightlycloudyPolartwilightColourElement,
   events: {
     
   }
  });
 
 